// Customizable Area Start
import React, { useState, useEffect } from "react";
import { StyleSheet, Text, TouchableOpacity, View, Image } from "react-native";
import Drawer from "@material-ui/core/Drawer";
import CustomisableUserProfiles from "../../../blocks/CustomisableUserProfiles/src/CustomisableUserProfiles";
import NotiFication from "./Notification";
import { asyncLocalStorage, logOut, ROLE_ID } from "../../../framework/src/Utilities";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import * as IMG_CONST from '../../../blocks/dashboard/src/assets'

export default function DesktopMenue({ navigation }: { navigation: any }) {
  const [userData, setUserData] = useState<any>("");
  const [routeList, setrouteList] = useState<any>([]);
  const [openSubMenu, setOpenSubMenu] = useState<string | null>(null);
  const [selectedSubMenu, setSelectedSubMenu] = useState<string | null>(null);

  const urlParams = window.location.pathname.split('/').filter(Boolean).pop();

  useEffect(() => {
    const assignlist = () => {
      const user = JSON.parse(
        localStorage.getItem("loggedinUserInfo") || "{}"
      );
      let id = Number(user.role_id).toString()
      if (id === ROLE_ID.SURGEON) {
        setrouteList(routeListSurgeon);
      } else if (id === ROLE_ID.MATERIAL_MANAGER) {
        setrouteList(routeListMaterialManage);
      } else if (id === ROLE_ID.BOOKING_COORDINATOR) {
        setrouteList(routeListBookingCoordinator);
      } else {
        setrouteList(routeListSalesRep);
      }
    };

    assignlist();
    getUserProfile();
  }, [userData]);

  const getUserProfile = async () => {
    let status = await asyncLocalStorage.getItem("userStatus");
    setUserData(status);
  };

  type Anchor = "right";

  const [showPrfole, setShowProfile] = useState(false);

  const [state, setState] = React.useState({
    right: false,
  });

  const toggleDrawer = (anchor: Anchor, open: boolean) => (
    event: React.KeyboardEvent | React.MouseEvent
  ) => {
    if (
      event.type === "keydown" &&
      ((event as React.KeyboardEvent).key === "Tab" ||
        (event as React.KeyboardEvent).key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
    setShowProfile(false);
  };

  const changeRoute = (route: any) => {
    navigation.navigate(route);
  };

  const openDrawer = () => {
    setShowProfile(true);
    setState({
      right: true,
    });
  };
  const openDrawer2 = () => {
    setShowProfile(false);
    setState({
      right: true,
    });
  };

  const routeListSurgeon = [
    {
      name: "Dashboard",
      routename: "Dashboard",
      status: "confirmed",
      Desktop: IMG_CONST.homeDesktop
    },
    {
      name: "Profile",
      routename: "Profile",
      status: "confirmed",
      Desktop: IMG_CONST.userDesktop
    },
    {
      name: "Start New Booking",
      routename: "CreateBooking",
      status: "confirmed",
      Desktop: IMG_CONST.plusDesktop
    },
    {
      name: "My Facility",
      routename: "UserFacilities",
      status: "confirmed",
      Desktop: IMG_CONST.hospitalDesktop
    },
    {
      name: "Catalogue",
      routename: "CatalogueManufacturer",
      status: "confirmed",
      Desktop: IMG_CONST.calendarDesktop,
      subMenu: [
        {
          name: "AI Assistance",
          routename: "CatalougeDesktopManufacAI",
        },
        {
          name: "Manual addition",
          routename: "CatalogueManufacturer",
        },
      ],
    },
    {
      name: "History",
      routename: "History",
      status: "confirmed",
      Desktop: IMG_CONST.calendarDesktop
    },
    {
      name: "Tracking",
      routename: "Tracking",
      status: "confirmed",
      image: IMG_CONST.tracking,
      Desktop: IMG_CONST.navigationDesktop
    },
    {
      name: "Invite Users",
      routename: "AddTeam",
      status: "confirmed",
      Desktop: IMG_CONST.personDesktop
    },
    {
      name: "Notification",
      routename: "Notification",
      status: "confirmed",
      Desktop: IMG_CONST.bellDesktop
    },
    {
      name: "Logout",
      status: "confirmed",
      routename: "Logout",
      Desktop: IMG_CONST.logout2
    },
  ];

  const routeListMaterialManage = [
    {
      name: "Dashboard",
      routename: "Dashboard",
      status: "confirmed",
      image: IMG_CONST.homeIcon,
      Desktop: IMG_CONST.homeDesktop
    },
    {
      name: "Profile",
      routename: "Profile",
      status: "confirmed",
      image: IMG_CONST.personsmall,
      Desktop: IMG_CONST.userDesktop
    },
    {
      name: "My Facility",
      routename: "UserFacilities",
      status: "confirmed",
      image: IMG_CONST.hospital,
      Desktop: IMG_CONST.hospitalDesktop
    },
    {
      name: "Invite Users",
      routename: "AddTeam",
      status: "confirmed",
      image: IMG_CONST.invite,
      Desktop: IMG_CONST.personDesktop
    },
    {
      name: "Catalogue",
      routename: "CatalogueManufacturer",
      status: "confirmed",
      Desktop: IMG_CONST.calendarDesktop,
      subMenu: [
        {
          name: "AI Assistance",
          routename: "CatalougeDesktopManufacAI",
        },
        {
          name: "Manual addition",
          routename: "CatalogueManufacturer",
        },
      ],
    },
    {
      name: "Generate Reports ",
      routename: "UserActivityReport",
      status: "confirmed",
      image: IMG_CONST.plus,
      Desktop: IMG_CONST.calendarDesktop
    },
    {
      name: "Validate New Manager",
      routename: "ValidateManager",
      status: 'confirmed',
      image: IMG_CONST.validateNewManager,
      Desktop: IMG_CONST.calendarDesktop
    },
    {
      name: "Validate New Surgeon",
      routename: "ValidateNewSurgeonBlock",
      status: 'confirmed',
      image: IMG_CONST.userIcon,
      Desktop: IMG_CONST.cameraDesktop
    },
    {
      name: "New Material",
      routename:
        window.screen.width < 950 ? "ChooseAddMaterialType" : "NewMaterial",
      status: 'confirmed',
      image: IMG_CONST.plus,
      Desktop: IMG_CONST.plusDesktop
    },
    {
      name: "History",
      routename: "History",
      status: 'confirmed',
      image: IMG_CONST.calendar,
      Desktop: IMG_CONST.calendarDesktop
    },
    {
      name: "Notification",
      routename: "Notification",
      status: "confirmed",
      image: IMG_CONST.bell,
      Desktop: IMG_CONST.bellDesktop
    },
    {
      name: "Logout",
      status: "confirmed",
      routename: "Logout",
      Desktop: IMG_CONST.logout2,
      image: "",
    },
  ];

  const routeListBookingCoordinator = [
    {
      name: "Dashboard",
      status: "confirmed",
      routename: "Dashboard",
      image: IMG_CONST.homeIcon,
      Desktop: IMG_CONST.homeDesktop
    },
    {
      name: "Profile",
      status: "confirmed",
      routename: "Profile",
      image: IMG_CONST.personsmall,
      Desktop: IMG_CONST.userDesktop
    },
    {
      name: "Generate Reports ",
      routename: "UserActivityReport",
      status: "confirmed",
      image: IMG_CONST.plus,
      Desktop: IMG_CONST.calendarDesktop
    },
    {
      name: "Invite Users",
      routename: "AddTeam",
      status: "confirmed",
      image: IMG_CONST.invite,
      Desktop: IMG_CONST.personDesktop
    },
    {
      name: "Validate BC",
      status: 'confirmed',
      routename: "ValidateBC",
      image: IMG_CONST.userIcon,
      Desktop: IMG_CONST.cameraDesktop
    },
    {
      name: "Catalogue",
      routename: "CatalogueManufacturer",
      status: "confirmed",
      Desktop: IMG_CONST.calendarDesktop,
      subMenu: [
        {
          name: "AI Assistance",
          routename: "CatalougeDesktopManufacAI",
        },
        {
          name: "Manual addition",
          routename: "CatalogueManufacturer",
        },
      ],
    },
    {
      name: "My Facility",
      status: "confirmed",
      routename: "UserFacilities",
      image: IMG_CONST.hospital,
      Desktop: IMG_CONST.hospitalDesktop
    },
    {
      name: "History",
      routename: "History",
      status: 'confirmed',
      image: IMG_CONST.plus,
      Desktop: IMG_CONST.plusDesktop
    },
    {
      name: "Notification",
      routename: "Notification",
      status: "confirmed",
      image: IMG_CONST.calendar,
      Desktop: IMG_CONST.calendarDesktop
    },
    {
      name: "Logout",
      status: "confirmed",
      routename: "Logout",
      Desktop: IMG_CONST.logout2,
      image: "",
    },
  ];

  const routeListSalesRep = [
    {
      name: "Dashboard",
      status: "confirmed",
      routename: "Dashboard",
      image: IMG_CONST.homeImg,
      Desktop: IMG_CONST.homeDesktop
    },
    {
      name: "Profile",
      status: "confirmed",
      routename: "Profile",
      image: IMG_CONST.personsmall,
      Desktop: IMG_CONST.userDesktop
    },
    {
      name: "My Facility",
      routename: "UserFacilities",
      status: "confirmed",
      image: IMG_CONST.hospital,
      Desktop: IMG_CONST.hospitalDesktop
    },
    {
      name: "History",
      status: "confirmed",
      routename: "History",
      image: IMG_CONST.plus,
      Desktop: IMG_CONST.plusDesktop
    },
    {
      name: "Manage Manufacturers",
      status: "confirmed",
      routename: "UserManufacturers",
      image: IMG_CONST.hospital,
      Desktop: IMG_CONST.hospitalDesktop
    },
    {
      name: "Manage Materials",
      status: "confirmed",
      routename: "NewMaterial",
      image: IMG_CONST.hospital,
      Desktop: IMG_CONST.hospitalDesktop
    },
    {
      name: "Catalogue",
      routename: "CatalogueManufacturer",
      status: "confirmed",
      Desktop: IMG_CONST.calendarDesktop,
      subMenu: [
        {
          name: "AI Assistance",
          routename: "CatalougeDesktopManufacAI",
        },
        {
          name: "Manual addition",
          routename: "CatalogueManufacturer",
        },
      ],
    },
    {
      name: "Notification",
      status: "confirmed",
      routename: "Notification",
      image: IMG_CONST.tracking,
      Desktop: IMG_CONST.navigationDesktop
    },
    {
      name: "Out Of Office",
      status: "confirmed",
      routename: "OutOfOffice",
      image: IMG_CONST.bell,
      Desktop: IMG_CONST.bellDesktop
    },
    {
      name: "Logout",
      status: "confirmed",
      routename: "Logout",
      Desktop: IMG_CONST.logout2,
      image: "",
    },
  ];
const handlePress = (item: any) => {
  if (item.name === "Logout") {
    logOut();
  } else if (item.name === "Profile") {
    openDrawer();
  } else if (item.name === "Notification") {
    openDrawer2();
  } else if (item.subMenu) {
    const willOpen = openSubMenu !== item.name;
    setOpenSubMenu(willOpen ? item.name : null);
    changeRoute(item.routename);
  } else {
    setOpenSubMenu(null);
    changeRoute(item.routename);
  }
};
const handleSubMenuPress = (subItem: any) => {
  setSelectedSubMenu(subItem.tabKey);
  navigation.navigate(subItem.routename, { subMenuKey: subItem.tabKey });
};

  useEffect(() => {
  const catalogueItem = routeList.find((item: any) => item.name === "Catalogue");

  if (
    catalogueItem?.subMenu &&
    (urlParams === catalogueItem.routename ||
      catalogueItem.subMenu.some((sub: any) => sub.routename === urlParams))
  ) {
    setOpenSubMenu("Catalogue");
  }
}, [urlParams, routeList]);
  return (
    <View style={styles.desktopMenu}>
      <View>
        {routeList.map((item: any) => {
          const isActive = item.routename === urlParams || item.subMenu?.some((subItem: any) => subItem.routename === urlParams);;
          const isSubMenuOpen = openSubMenu === item.name;
          return (
            <View key={item.name} style={isActive ? { backgroundColor: "#fff" } : {}}>
              {item.status === "pending" ? (
                <View style={styles.menuWrapper}>
                  <View
                    style={{
                      flexDirection: "row",
                      marginVertical: 10,
                      marginHorizontal: 24,
                    }}
                  >
                    <Image
                      source={item.Desktop}
                      style={{ height: 20, width: 20 }}
                    />

                    <Text style={styles.menuName2}>{item.name}</Text>
                  </View>
                </View>
              ) : (
                <>
                <TouchableOpacity
                  style={styles.menuWrapper}
                  onPress={() => handlePress(item)}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      marginVertical: 10,
                      marginHorizontal: 24,
                    }}
                  >
                    {item.name === "Logout" ? (
                      <ExitToAppIcon
                        style={{ color: "#ffff", height: 20, width: 20 }}
                      />
                    ) : (
                      <Image
                        source={item.Desktop}
                        style={{ height: 20, width: 20, tintColor: isActive ? "#4e3e71" : "#fff" }}
                      />
                    )}

                    <Text style={[styles.menuName, { color: isActive ? "#4e3e71" : "#fff" }]}>{item.name}</Text>
                  </View>
                </TouchableOpacity>
                {item.subMenu && isSubMenuOpen && (
            <View style={styles.subMenuContainer}>
              {item.subMenu.map((subItem: any) => {
                const isSubActive = subItem.routename === urlParams;
                return (
                  <TouchableOpacity
                    key={subItem.name}
                    style={styles.subMenuItem}
                    onPress={() => handleSubMenuPress(subItem)}
                  >
                    <Text
                      style={[
                        styles.subMenuText,
                        { color: "#4e3e71",fontWeight:isSubActive?'bold': 'normal'},
                      ]}
                    >
                       {subItem.name}
                    </Text>
                  </TouchableOpacity>
                );
              })}
            </View>
          )}
                </>
              )}
              
            </View>
          );
        })}
        {(["right"] as const).map((anchor) => (
          <React.Fragment key={anchor}>
            <Drawer
              anchor={anchor}
              open={state[anchor]}
              onClose={toggleDrawer(anchor, false)}
            >
              <View style={{ width: 400 }}>
                {showPrfole ? (
                  <CustomisableUserProfiles
                    id="CustomisableUserProfiles"
                    navigation={navigation}
                  />
                ) : (
                  <NotiFication navigation={navigation} />
                )}
              </View>
            </Drawer>
          </React.Fragment>
        ))}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  menuWrapper: {
    // paddingTop:
  },
  menuName: {
    fontSize: 15,
    paddingHorizontal: 5,
    marginVertical: "auto",
  },
  menuName2: {
    color: "#b2bac6",
    fontSize: 15,
    paddingHorizontal: 5,
    marginVertical: "auto",
  },
  desktopMenu: {
    flex: 0.15,
    flexDirection: "column",
    backgroundColor: "#4e3e71",
    paddingTop: 20,
  },
  subMenuContainer: {
  paddingLeft: 40,
  paddingBottom: 10,
  },
  subMenuItem: {
    paddingVertical: 6,
  },
  subMenuText: {
    fontSize: 14,
    paddingLeft: 10,
  },
});
// Customizable Area End
